import { BaseLayoutFactory } from "../global/base-layout-factory";
import { CustomPageProvider } from "./context/custom-page-context";
import { CustomPageComponent } from "./custom-page-component";

export function CustomPageFactory() {
    return (
        <BaseLayoutFactory>
            <CustomPageProvider>
                <CustomPageComponent />
            </CustomPageProvider>
        </BaseLayoutFactory>
    );
}
